<button
  mat-button
  (click)="yearSelectedEvent.emit(timePeriod.year)"
  class="box"
  [ngClass]="timePeriod.selected ? 'selected-box' : 'deselected-box'"
  [disabled]="toggleDisabled"
>
  <h4
    class="year-label"
    [ngClass]="
      timePeriod.selected ? 'selected-year-label' : 'deselected-year-label'
    "
  >
    {{ timePeriod.year }}
  </h4>
</button>
<div class="time-period-labels">
  <button
    mat-button
    class="time-period-btn"
    (click)="
      labelToggledEvent.emit({ year: timePeriod.year, value: label.value })
    "
    *ngFor="let label of timePeriod.labels"
    [disabled]="toggleDisabled"
  >
    <h4
      class="time-period-label"
      [ngClass]="
        label.selected
          ? 'selected-time-period-label'
          : 'deselected-time-period-label'
      "
    >
      {{ label.name }}
    </h4>
  </button>
</div>
